import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';
import { ErrorState } from '@tiendanube/components';

interface DraftOrderDetailsErrorProps {
  onRetryError: () => void;
}

function DraftOrderDetailsError({
  onRetryError,
}: DraftOrderDetailsErrorProps): JSX.Element {
  const { t } = useTranslation(Domain.ORDERS);
  return (
    <ErrorState
      title={t('draftOrders.detailsError.title')}
      action={{
        children: t('draftOrders.detailsError.action'),
        onClick: onRetryError,
      }}
    />
  );
}

export default DraftOrderDetailsError;
